export default "__VITE_ASSET__BSBBLz$R__"